import { Component } from '@angular/core';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {

  constructor(private router: Router, private route: ActivatedRoute) { }
  
  redirectPath(path: string) {
    let route = path != '' ? path : '/home';
    this.router.navigate([route]);
  }
}
